require('./RALastMovementsView.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const Immutable = require('immutable');
const classnames = require('classnames');

// @commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKCarousel = require('components/commons/OKCarousel/OKCarousel');

// @components
const RALastMovement = require('../../components/RALastMovement/RALastMovement');

// @actions
const brokerMyInvestments = require('actions/brokerMyInvestments');
const raLastMovementActions = require('../../actions/RALastMovement');

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const { getCarouselTabPerClick } = require('../../utilities/RATabDivider');
const { recordLink } = require('utilities/tagging');

// @constants
const { MYPROFILE_BROKER_URL } = require('constants/index');
const {
    CAROUSEL_FOR_SINGLE_TAB,
    GOAL_TRACKING_URL,
    MYPROFILE_BROKER_ROBO_URL,
    OBJECTIVE_TRACK_URL_PARA,
    PORTFOLIO_TRACKING_URL,
    PORTFOLIO_TRACK_URL_PARA,
    PROC_RA_GO_BACK,
    PROC_RA_LAST_MOVEMENTS,
    PROC_RA_LAST_MOVEMENTS_WALLET_INTERACTION,
} = require('../../raConstants/index');

class RALastMovementsView extends React.Component {
    constructor(props) {
        super(props);
        const {
            match: {params: { portfolioId }},
        } = props;

        this.state = {
            currentSliderProfileId: portfolioId ? portfolioId : 0,
        };
        this.handleBackClick = this.handleBackClick.bind(this);
    }

    componentDidMount() {
        const { fetchMyInvestments, immRAPortfolioDistribution } = this.props;
        if (!immRAPortfolioDistribution.get('hasRoboHired')) {
            fetchMyInvestments();
        }
    }

    getBreadcrumb() {
        const {
            match: {params: { redirectedFrom, portfolioId }},
        } = this.props;
        let parentTitle = formatText('breadcrumb-breadcrumb_roboLanding');
        let parentUrl = MYPROFILE_BROKER_ROBO_URL;
        if (redirectedFrom === OBJECTIVE_TRACK_URL_PARA) {
            parentTitle = formatText('breadcrumb-breadcrumb_objectiveTracking');
            parentUrl = `${GOAL_TRACKING_URL}/${portfolioId}`;
        } else if (redirectedFrom === PORTFOLIO_TRACK_URL_PARA) {
            parentTitle = formatText(
                'raPortfolioTracking-raPortfolioTracking_breadcrumbThird',
            );
            parentUrl = `${PORTFOLIO_TRACKING_URL}/${portfolioId}`;
        }

        return [
            {
                text: formatText('raManagementPlan-investments'),
                url: MYPROFILE_BROKER_URL,
            },
            ...(redirectedFrom === PORTFOLIO_TRACK_URL_PARA ||
            redirectedFrom === OBJECTIVE_TRACK_URL_PARA
                ? [
                      {
                          text: parentTitle,
                          url: parentUrl,
                      },
                  ]
                : []),
            {
                text: formatText('raLastMovements-movementsTitle'),
            },
        ];
    }

    handleBackClick() {
        recordLink(PROC_RA_LAST_MOVEMENTS, PROC_RA_GO_BACK);
        this.props.history.goBack();
    }

    buildHeaderSubPage() {
        const breadcrumb = this.getBreadcrumb();

        return (
            <div className="ra-last-movements-view__breadcrumb">
                <OKHeaderSubPage
                    finalTitle={formatText(
                        'raLastMovement-raLastMovement_pageTitle',
                    )}
                    breadcrumbConfig={breadcrumb}
                >
                    <OKButton
                        inverse
                        leftIcon="icon-anterior"
                        modifier="ghost"
                        onClick={this.handleBackClick}
                    >
                        <FormattedText value="common-back" />
                    </OKButton>
                </OKHeaderSubPage>
            </div>
        );
    }

    getPortfolioOptions(portfolios) {
        let options = [];
        portfolios.forEach(portfolio => {
            const portfolioId = portfolio.get('id');

            if (portfolio) {
                let optionLabel = portfolio.get('hasGoal')
                    ? portfolio.getIn(['goalInformation', 'name'])
                    : portfolio.get('name');

                if (
                    portfolios.size > CAROUSEL_FOR_SINGLE_TAB &&
                    optionLabel.length > 30
                ) {
                    optionLabel = optionLabel.slice(0, 17) + '...';
                }

                options.push({
                    index: portfolioId,
                    name: optionLabel,
                    portfolioIds: [portfolioId],
                });
            }
        });
        return options;
    }

    selectTab(item) {
        recordLink(
            PROC_RA_LAST_MOVEMENTS,
            PROC_RA_LAST_MOVEMENTS_WALLET_INTERACTION,
        );
        this.setState({ currentSliderProfileId: item.index });
    }

    buildSliderBlock(options) {
        return options.map((item, index) => {
            const activeClass = classnames({
                'ra-last-movements-view__tab-border':
                    item.index === this.state.currentSliderProfileId,
                'ra-last-movements-view__single-tab':
                    options.length === CAROUSEL_FOR_SINGLE_TAB,
            });
            const textAlignment = classnames({
                'ra-last-movements-view__text-align': options.length > 1,
            });
            return (
                <div
                    className={textAlignment}
                    key={index}
                    onClick={() => this.selectTab(item)}
                >
                    <div className={activeClass}>{item.name}</div>
                </div>
            );
        });
    }

    render() {
        const {
            changeLastMovementFilter,
            immLastMovement,
            immGlobalPosition,
            setFilter,
            requestLastMovement,
            immProfile,
        } = this.props;
        const portfolios = immGlobalPosition.get('totalPortfolios');
        const lastMovementFilter = immLastMovement.getIn([
            'lastMovementsRow',
            'filter',
        ]);
        let immRowsContent = immLastMovement.getIn(
            ['lastMovement', 'transactions'],
            Immutable.List(),
        );
        const isFetchingMovements = immLastMovement.get('isFetching');
        let options = this.getPortfolioOptions(portfolios);
        let activeTab = 0;

        if (options.length > 1) {
            options.splice(0, 0, {
                index: 0,
                portfolioId: 0,
                name: formatText('raLastMovements-defaultTab'),
            });
        }

        if (options.length == 1 && this.state.currentSliderProfileId == 0) {
            this.setState({ currentSliderProfileId: options[0].index });
        }

        const tabContent = options.map(item => {
            if (this.state.currentSliderProfileId == item.index) {
                return (
                    <RALastMovement
                        rowsContent={immRowsContent}
                        filter={lastMovementFilter}
                        profileObject={item}
                        key={this.state.currentSliderProfileId}
                        fullView={true}
                        requestLastMovement={requestLastMovement}
                        isFetching={isFetchingMovements}
                        immLastMovement={immLastMovement}
                        setFilter={setFilter}
                        changeLastMovementFilter={changeLastMovementFilter}
                        immProfile={immProfile}
                    />
                );
            }
        });

        const tabsPerClick = getCarouselTabPerClick(options);
        const blocks = this.buildSliderBlock(options);
        const headerSubPage = this.buildHeaderSubPage();
        const settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: tabsPerClick,
            slidesToScroll: tabsPerClick,
            draggable: false,
            arrows: false,
            initialSlide: activeTab,
        };

        return (
            <div className="ra-last-movements-view grid-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover
                            size="medium"
                            section="broker"
                            customClass="ra-last-movements-view__cover"
                        >
                            {headerSubPage}
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="conatiner-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="ra-last-movements-view__page-container">
                                <div className="ra-last-movements-view__page-carousel">
                                    <OKCarousel
                                        numberSlides={options.length}
                                        settings={settings}
                                        blocks={blocks}
                                        leftButtonClass="ra-last-movements-view__left-button"
                                        rightButtonClass="ra-last-movements-view__right-button"
                                        leftIcon="icon-anterior"
                                        rightIcon="icon-siguiente"
                                        displayDynamicTab={true}
                                    />
                                    {tabContent}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

RALastMovementsView.propTypes = {
    changeLastMovementFilter: PropTypes.func.isRequired,
    fetchMyInvestments: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    immLastMovement: PropTypes.object.isRequired,
    immRAPortfolioDistribution: PropTypes.object.isRequired,
    match: PropTypes.object,
    removeFilter: PropTypes.func.isRequired,
    requestLastMovement: PropTypes.func.isRequired,
    setFilterLabel: PropTypes.func.isRequired,
    setFilter: PropTypes.func.isRequired,
    immProfile: PropTypes.object.isRequired,
};

module.exports = connect(
    state => ({
        immLastMovement: state.raLastMovement,
        immRAPortfolioDistribution: state.raPortfolioDistribution,
        immGlobalPosition: state.raGlobalPosition,
        immProfile: state.profile,
    }),
    {
        changeLastMovementFilter:
            raLastMovementActions.changeLastMovementFilter,
        fetchMyInvestments: brokerMyInvestments.fetchMyInvestments,
        removeFilter: raLastMovementActions.removeFilter,
        requestLastMovement: raLastMovementActions.requestLastMovement,
        setFilter: raLastMovementActions.setFilter,
    },
)(withRouter(RALastMovementsView));
